import { Checkbox } from '@headlessui/react';
import clsx from 'clsx';

import CheckIcon from '~/shared/assets/icons/check.svg';

export interface CheckboxOptionProps {
  id: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  className?: string;
}

export default function CheckboxOption({ id, checked, onChange, className }: CheckboxOptionProps) {
  return (
    <Checkbox
      id={id}
      checked={checked}
      onChange={onChange}
      className={clsx(
        'group block size-5 p-[4px] rounded-md border border-gray-400 bg-white data-checked:bg-primary-500 ring-0 active:ring-primary-300 focus:ring-primary-500 cursor-pointer',
        className
      )}
    >
      <CheckIcon className="text-white stroke-2 size-2.5 opacity-0 group-data-checked:opacity-100 transition duration-200 ease-in-out" />
    </Checkbox>
  );
}
